var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"custom-button",class:{
    'custom-button--big': _vm.type === 'big',
    'custom-button--common': _vm.type === 'common',
    'custom-button--with-icon': _vm.icon,
  },on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('span',{staticClass:"custom-button__icon"},[_c('img',{attrs:{"src":_vm.iconSrc,"alt":_vm.icon}})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }